import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import api from "../api/axios"; 
import "./MyAgents.css";
import { toast } from "react-toastify";

export default function MyAgents() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [agentToDelete, setAgentToDelete] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  // Extract variables passed from Home.jsx Link state
  const { filter } = location.state || {};

  useEffect(() => {
    fetchAgents();
  }, [location.state]);

const fetchAgents = async () => {
  try {
    setLoading(true);

    const roleId = localStorage.getItem("role_id");
const endpoint = roleId ? "/my-agents" : "/agents";
const res = await api.get(endpoint);

    if (res.data.length > 0) {
      const firstAgent = res.data[0];

      // ✅ Store all three
      localStorage.setItem("userId", firstAgent.userId);
      localStorage.setItem("commonId", firstAgent.commonId);
      localStorage.setItem("workspaceId", firstAgent.workspaceId);
    }

    if (filter) {
      const filtered = res.data.filter(a => a.type === filter);
      setAgents(filtered);
    } else {
      setAgents(res.data);
    }

  } catch (err) {
    console.error("Error fetching agents:", err);
  } finally {
    setLoading(false);
  }
};

  // ✅ NEW: Functional Delete logic using the universal /api/agents/:id endpoint
  const handleDelete = async () => {

  if (!agentToDelete) return;

  try {

    await api.delete(`/agents/${agentToDelete}`);

    setAgents(
      agents.filter(a => a.id !== agentToDelete)
    );

    toast.success("Agent deleted successfully!");

    setShowDeleteModal(false);
    setAgentToDelete(null);

  } catch (err) {

    console.error("Delete failed:", err);

    toast.error(
      "Failed to delete agent: " +
      (err.response?.data?.message || err.message)
    );

  }
};

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "my-agents-status-active";
      case "draft":
        return "my-agents-status-draft";
      default:
        return "my-agents-status-default";
    }
  };

  return (
    <div className="d-flex ">
      <div className="flex-grow-1 d-flex flex-column overflow-auto">
        <div className="pt-4 px-4 pb-0">
          <h4 className="fw-bold mb-0">My Agents</h4>
          <p className="text-muted small">
            {filter ? `Showing agents for ${filter}` : "Manage and monitor your AI agents"}
          </p>
          <hr />
        </div>

        <div className="container-fluid px-4 pb-4">
          <div className="row g-4">
           {loading ? (
  <div className="ps-3">Loading agents...</div>
) : agents.length > 0 ? (
  agents.map((agent) => (
    <div key={agent.id} className="col-lg-3 col-md-6 col-sm-12">
      <div
        className="bg-white border rounded-3 p-3 h-100 d-flex flex-column justify-content-between my-agents-card cursor-pointer"
        style={{ cursor: "pointer" }}
        onClick={() =>
          navigate("/ScreeningAgent", { state: { existingAgent: agent } })
        }
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex gap-2">
            <img src="/images/IconHome.svg" alt="" width="28" height="28" />
            <div className="d-flex flex-column">
              <div className="fw-bold">{agent.name}</div>
              <small
                className="text-muted text-truncate"
                style={{ maxWidth: "150px" }}
              >
                {agent.description}
              </small>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <span className="text-secondary text-ssize agent-tag-pill">
            {agent.model || "ChatGPT 4.0"} • {agent.tone || "Formal"}
          </span>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <span
              className={`rounded-circle my-agents-status-dot ${getStatusClass(
                "active"
              )}`}
            />
            <small className="text-muted">Active</small>
          </div>

          <div onClick={(e) => e.stopPropagation()}>
             <Link
                          to={
                            agent.type === "RFP Creator Agent"
                              ? `/chat-bot?agentId=${agent.id}`
                              : `/ChatInterface/${agent.id}`
                          }
                          className="btn btn-primary btn-sm px-3 text-decoration-none me-1"
                        >
                          Chat
                        </Link>
 

            <button
              className="btn btn-sm dropdown-toggle my-agents-no-caret"
              data-bs-toggle="dropdown"
            >
              <i className="bi bi-three-dots-vertical"></i>
            </button>

            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <button className="dropdown-item">Share</button>
              </li>
              <li>
                <button
                  className="dropdown-item text-danger"
                  onClick={() => {
  setAgentToDelete(agent.id);
  setShowDeleteModal(true);
}}
                >
                  Delete
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  ))
) : (
  <div className="text-center py-5 w-100">
    <img
      src="/images/IconHome.svg"
      alt=""
      width="80"
      className="mb-3 opacity-25"
    />
    <h5 className="text-muted">No agents present</h5>
    <p className="text-secondary small">
      You haven't created any agents for this category yet.
    </p>
    <button
      className="btn btn-outline-primary btn-sm mt-2"
      onClick={() => navigate("/home")}
    >
      Go Back to Add Agent
    </button>
  </div>
)}
          </div>
        </div>
      </div>
      {showDeleteModal && (
  <div
    className="modal fade show d-block"
    onClick={() => {
      setShowDeleteModal(false);
      setAgentToDelete(null);
    }}
    style={{
      background: "rgba(0,0,0,0.45)",
      zIndex: 9999,
    }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div
        className="modal-content border-0"
        onClick={(e) => e.stopPropagation()}
        style={{
          borderRadius: "18px",
          overflow: "hidden",
        }}
      >
        <div className="modal-body text-center p-4">

          <div
            style={{
              width: "68px",
              height: "68px",
              background: "#FEECEC",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 18px",
            }}
          >
            <i
              className="bi bi-trash3"
              style={{
                color: "#ef4444",
                fontSize: "28px",
              }}
            ></i>
          </div>

          <h5
            style={{
              fontWeight: 700,
              marginBottom: "10px",
            }}
          >
            Delete Agent?
          </h5>

          <p
            style={{
              color: "#6b7280",
              fontSize: "14px",
              marginBottom: "26px",
            }}
          >
            This action cannot be undone.
          </p>

          <div className="d-flex justify-content-center gap-3">

            <button
              className="btn btn-light px-4"
              onClick={() => {
                setShowDeleteModal(false);
                setAgentToDelete(null);
              }}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger px-4"
              onClick={handleDelete}
            >
              Delete
            </button>

          </div>

        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
}